import { AuthUIWrapper } from "components/Auth/AuthUIWrapper";
import Async from "components/DesignSystem/AsyncComponents/Async";
import { usePageTitle } from "hooks/usePageTitle";
import { useRedirectOnAuth } from "hooks/useRedirectOnAuth";
import { useToast } from "hooks/useToast";
import { useContext, useEffect, useState } from "react";
import { profileApi, useLazyGetUserProfileQuery } from "store/apis/profile";
import { BackendError } from "types/utils/error";
import authContext from "../jwt_context&axios/authContext";
import "../static/styles/components/onboarding.css";
import { OnBoardingAction } from "components/onboarding/onboardingAction/OnBoardingAction";

export const Profile = () => {
  usePageTitle("Group creation");
  const { alertToast } = useToast();
  const { updateUser } = useContext(authContext);
  const [isLoading, setLoading] = useState(true);

  useRedirectOnAuth();

  const [getProfile] = useLazyGetUserProfileQuery();

  let updateUserData = async () => {
    try {
      const res = await getProfile().unwrap();
      updateUser({ data: { data: res } });
      profileApi.util.invalidateTags(["PROFILE"]);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      alertToast({ message: (e as BackendError).data?.error?.message });
    }
  };

  useEffect(() => {
    updateUserData();
  }, []);

  return (
    <Async.Root isSuccess={!isLoading} isLoading={isLoading} isEmpty={false}>
      <Async.Empty>
        <></>
      </Async.Empty>
      <Async.Success>
        <AuthUIWrapper isPhoneVerify className="sm:t-overflow-auto">
          <OnBoardingAction />
        </AuthUIWrapper>
      </Async.Success>
    </Async.Root>
  );
};
